import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import beetinqTeamService from "./beetinqTeamService";

const initialState = {
  members: [],
  isLoading: false,
  isError: false,
  message: "",
  createLoading: false,
  createError: false,
  createMessage: "",
  updateLoading: false,
  updateError: false,
  updateMessage: "",
};

export const listBeetinqTeamMembers = createAsyncThunk("beetinqTeam/list", async (_, thunkAPI) => {
  try {
    return await beetinqTeamService.listTeamMembers();
  } catch (error) {
    return thunkAPI.rejectWithValue(error?.message || "Beetinq ekibi yüklenemedi.");
  }
});

export const addBeetinqTeamMember = createAsyncThunk("beetinqTeam/add", async (payload, thunkAPI) => {
  try {
    return await beetinqTeamService.addTeamMember(payload);
  } catch (error) {
    return thunkAPI.rejectWithValue(error?.message || "Ekip üyesi eklenemedi.");
  }
});

export const setBeetinqTeamMemberStatus = createAsyncThunk("beetinqTeam/setStatus", async (payload, thunkAPI) => {
  try {
    return await beetinqTeamService.setTeamMemberStatus(payload);
  } catch (error) {
    return thunkAPI.rejectWithValue(error?.message || "Ekip üyesi güncellenemedi.");
  }
});

export const updateBeetinqTeamMember = createAsyncThunk("beetinqTeam/update", async (payload, thunkAPI) => {
  try {
    return await beetinqTeamService.updateTeamMember(payload);
  } catch (error) {
    return thunkAPI.rejectWithValue(error?.message || "Ekip üyesi düzenlenemedi.");
  }
});

const beetinqTeamSlice = createSlice({
  name: "beetinqTeam",
  initialState,
  reducers: {
    resetBeetinqTeamMessages: (state) => {
      state.message = "";
      state.createMessage = "";
      state.updateMessage = "";
      state.isError = false;
      state.createError = false;
      state.updateError = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(listBeetinqTeamMembers.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.message = "";
      })
      .addCase(listBeetinqTeamMembers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.members = action.payload || [];
      })
      .addCase(listBeetinqTeamMembers.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(addBeetinqTeamMember.pending, (state) => {
        state.createLoading = true;
        state.createError = false;
        state.createMessage = "";
      })
      .addCase(addBeetinqTeamMember.fulfilled, (state, action) => {
        state.createLoading = false;
        state.createError = false;
        if (action.payload?.id) {
          state.members.unshift(action.payload);
        }
      })
      .addCase(addBeetinqTeamMember.rejected, (state, action) => {
        state.createLoading = false;
        state.createError = true;
        state.createMessage = action.payload;
      })
      .addCase(setBeetinqTeamMemberStatus.pending, (state) => {
        state.updateLoading = true;
        state.updateError = false;
        state.updateMessage = "";
      })
      .addCase(setBeetinqTeamMemberStatus.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.updateError = false;
        const updated = action.payload;
        const target = state.members.find((member) => member.id === updated?.id);
        if (target) {
          Object.assign(target, updated);
        }
      })
      .addCase(setBeetinqTeamMemberStatus.rejected, (state, action) => {
        state.updateLoading = false;
        state.updateError = true;
        state.updateMessage = action.payload;
      })
      .addCase(updateBeetinqTeamMember.pending, (state) => {
        state.updateLoading = true;
        state.updateError = false;
        state.updateMessage = "";
      })
      .addCase(updateBeetinqTeamMember.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.updateError = false;
        const updated = action.payload;
        const target = state.members.find((member) => member.id === updated?.id);
        if (target) {
          Object.assign(target, updated);
        }
      })
      .addCase(updateBeetinqTeamMember.rejected, (state, action) => {
        state.updateLoading = false;
        state.updateError = true;
        state.updateMessage = action.payload;
      });
  },
});

export const { resetBeetinqTeamMessages } = beetinqTeamSlice.actions;
export default beetinqTeamSlice.reducer;
